import { useEffect, useState } from "react"
import { Layout } from "../../../GlobalComponent/Layout/Layout"
import AmbulanceServiceFormStepOne from "../StepOneForm/AmbulanceServiceFormStepOne"
import { getAmbulanceProviders } from "../../../Http/Index"
import { createAmbulanceProvider, getGeoCode, updateAmbulanceProviderData } from "../Action/action"
import { ShowAlert } from "../../../GlobalComponent/Alerts/Alert"
import AmbulanceRateCard from "../../AmbulanceRateCard/AmbulanceRateCard"
import { Box, Tab, TabList, TabPanel, TabPanels, Tabs } from "@chakra-ui/react"
import ManageCoverageAreas from "../CoverageAreas/ManageCoverageAreas"

export interface AmbulanceProviderInterface {
    operatorName: string,
    address: {
        addressLine1: string,
        city: string,
        pinCode: string,
        country: string,
        state: string,
    },
    baseLocation?: { type: string; coordinates: number[] },
    coverageAreas?: {
        name: string,
        location?: { type: string; coordinates: number[] },
        city?: string,
        rangeInKm?: number,
        isHospital?: boolean,
        ambulancePlaced?: boolean,
    }[],
    ambulanceTypes?: string[],
    fleet?: Record<string, number>,
    manpower?: string[],
    equipment?: string[],
    eta?: Record<string, { min: number; max: number }>,
    pricing?: { rateType: string; baseRateNotes: string; currency: string },
    contact: {
        personName?: string,
        mobile: { countryCode: string; number: string; isPrimary?: boolean; isWhatsApp?: boolean }[],
        email?: string[];
    };
    communicationMethods?: string[],
    payment?: { methods: string[]; terms: string },
    complianceCertified?: boolean,
    complianceDoc?: string,
    hygieneOk?: boolean,
    photos?: any[],
    gpsAvailable?: boolean,
    availability?: string,
    notes?: string,
}

export const AmbulanceProviders = () => {
    const [selectedTab, setSelectedTab] = useState(0);
    const [provider, setProvider] = useState([])
    const [clearFormOne, setClearFormOne] = useState<Boolean>(false);
    const [clearFormTwo, setClearFormTwo] = useState<Boolean>(false);
    const handleTabChange = (index:number) => {
        setSelectedTab(index);
        setClearFormOne(!clearFormOne);  
        setClearFormTwo(!clearFormTwo);
      
    }
    const getAllAmbulanceProviders = async () => {
        const result = await getAmbulanceProviders();
        setProvider((result?.data?.data) || [])
    }

    const handleCollectData = async (data: any, handleClear: any, action: string) => {
        const addressText = `${data.addressLine1} ${data.city} ${data.state} ${data.pinCode}`;
        const baseResponse = await getGeoCode(addressText);

        const resolvedCoverageAreas = data.coverageAreas.map((area: any) => ({
            name: area.name,
            city: area.city || '',
            rangeInKm: area.rangeInKm,
            isHospital: area.isHospital,
            ambulancePlaced: area.ambulancePlaced,
            ...(area.location ? { location: area.location } : {}),
        }));

        const payloadBuilder: AmbulanceProviderInterface = {
            operatorName: data.name,
            address: {
                addressLine1: data.addressLine1 || "",
                city: data.city,
                state: data.state,
                country: data.country,
                pinCode: data.pinCode
            },
            ...(baseResponse ? {
                baseLocation: {
                    type: 'Point',
                    coordinates: [Number(baseResponse.lng), Number(baseResponse.lat)],
                }
            } : {}),
            coverageAreas: resolvedCoverageAreas,
            ambulanceTypes: data.ambulanceTypes,
            fleet: data.fleet,
            manpower: data.manpower,
            equipment: data.equipment,
            eta: data.eta,
            pricing: {
                rateType: data.rateType,
                baseRateNotes: data.baseRateNotes,
                currency: data.currency,
            },
            contact: {
                personName: data.contactPersonName,
                mobile: data.contacts,
                ...(data?.emails?.length?{email: data.emails}:{email:[]})
            },
            communicationMethods: data.communicationMethods,
            payment: { methods: data.paymentMethods, terms: data.paymentTerms },
            complianceCertified: data.complianceCertified,
            complianceDoc: data.complianceDoc,
            hygieneOk: data.hygieneOk,
            photos: data.photos || [],
            gpsAvailable: data.gpsAvailable,
            availability: data.availability,
            notes: data.notes,
        };

        if (action === "create") {
            await handleCreateAmbulanceProvider(payloadBuilder);
            clearFormData(handleClear);
        } else {
            await updateAmbulanceProvider(data?.providerId, payloadBuilder);
            clearFormData(handleClear);
        }
    }

    const handleCreateAmbulanceProvider = async (ProviderPayload: any) => {
        const res = await createAmbulanceProvider(ProviderPayload);
        if (res) {
            ShowAlert("success", "Ambulance provider created  successfully");
            //need to move next step 
            //rate card
        }
    }
    const updateAmbulanceProvider = async (providerId: string, ProviderPayload: any) => {
        const res = await updateAmbulanceProviderData(providerId, ProviderPayload);
        if (res) {
            ShowAlert("success", "Ambulance provider updated  successfully");
            //need to move next step 
            //rate card
        }
    }

    const clearFormData = (handleClear: any) => {
        getAllAmbulanceProviders();
        handleClear()
    }
    const deleteProvider=()=>{
        getAllAmbulanceProviders();
    };

  
    useEffect(() => {
        getAllAmbulanceProviders()
    }, [])
    // console.log('provider:', provider);

    return <>
        <Layout>
            <Box style={{width:"100%",height:"50px"}}>
                <Tabs index={selectedTab} onChange={handleTabChange} variant="soft-rounded" colorScheme="green">
                <TabList>
                    <Tab>Ambulance Provider</Tab>
                    <Tab>Ambulance RateCard</Tab>
                    <Tab>Coverage Areas</Tab>
                </TabList>
                <TabPanels>
                    <TabPanel>
                        <AmbulanceServiceFormStepOne clearFormOne={clearFormOne} setClearFormOne={setClearFormOne} providers={provider} onNext={handleCollectData} deleteProvider={deleteProvider}  />
                    </TabPanel>
                    <TabPanel>
                        <AmbulanceRateCard providers={provider} clearFormTwo={clearFormTwo} setClearFormTwo={setClearFormTwo} />
                    </TabPanel>
                    <TabPanel>
                        <ManageCoverageAreas providers={provider} />
                    </TabPanel>
                </TabPanels>

                </Tabs>
                
            </Box>
        </Layout>
    </>

}